import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  name: 'ed-error'
})
class EdError extends Vue {

  @Prop() readonly message: string;
  @Prop() readonly icon: string;
  @Prop() readonly actionLabel: string;
  @Prop() readonly notAction: boolean;

  public readonly action: string = 'action';

  get messageText() {
    return this.message || this.$i18n.t('errors.load');
  }

  get actionText() {
    return this.actionLabel || this.$i18n.t('common.refresh');
  }

  get iconName() {
    return this.icon || 'bug';
  }

  refresh() {
    this.$emit(this.action);
  }

}

export default Vue.component('ed-error', EdError);